import React from 'react';
import { useState, CSSProperties } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import './Loading.css';
const Loading = () => {

    
    let [color, setColor] = useState("#FF26B6");
    return (
        <>
            <PulseLoader color={color} className='md:ml-[50%] dark:text-slate-200' />
        </>
    );
};

export default Loading;